import { render } from "react-dom";
import { App } from "./components/App";
import "./view/index.css";

render(<App />, document.getElementById("main"));